/**
 * @file index.tsx
 *
 * @fileoverview Renders a job detail bradcrumbs.
 */
import { useIntl } from 'react-intl';
import Breadcrumbs from '~/jobiqo/components/Breadcrumbs';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { Job } from '~/jobiqo/types/types';
import { getJobDetailBreadcrumbItems } from './utils';

interface JobDetailBreadcrumbsProps {
  /**
   * The job.
   */
  job: Job;
}

export default function JobDetailBreadcrumbs({
  job,
}: JobDetailBreadcrumbsProps) {
  const intl = useIntl();
  const { JOBS } = useFrontendConfig();
  const JOBS_PAGE = JOBS.JOBS_PAGE;
  const breadcrumbItems = getJobDetailBreadcrumbItems({
    job,
    jobsPage: JOBS_PAGE,
    jobsLabel: intl.formatMessage({ id: 'jobs', defaultMessage: 'Jobs' }),
  });

  return <Breadcrumbs items={breadcrumbItems} />;
}

export { JobDetailBreadcrumbs };
